<template>
  <PageVenueFilter :value="venueId" @input="$store.dispatch('pos/general/selectVenueId', $event)">
    <AssignedStockProducts v-if="venueId" :venueId="venueId" :isProcurementView="true" />
  </PageVenueFilter>
</template>

<script>
import { mapGetters } from "vuex";
import PageVenueFilter from "@/components/Custom/PageVenueFilter.vue";
import AssignedStockProducts from "./AssignedStockProducts.vue";

export default {
  components: {
    PageVenueFilter,
    AssignedStockProducts
  },
  computed: {
    ...mapGetters({
      venueId: "pos/general/selectedVenueId"
    })
  }
};
</script>